import { render, staticRenderFns } from "./posterView.vue?vue&type=template&id=19bb42b5&scoped=true"
import script from "./posterView.vue?vue&type=script&lang=js"
export * from "./posterView.vue?vue&type=script&lang=js"
import style0 from "./posterView.vue?vue&type=style&index=0&id=19bb42b5&prod&lang=css"
import style1 from "./posterView.vue?vue&type=style&index=1&id=19bb42b5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19bb42b5",
  null
  
)

export default component.exports